import * as React from "react";
import classnames from "classnames";
import { Hr } from "@grandvisionhq/elements";
/* empty css                             */
import { useProductDetailSlots } from "../../../../../../slots/slots/context.js";
import { ProductTag } from "../../../../components/ProductTag/modules/EcommContent/components/ProductTag/ProductTag.js";
import { SizeGuideModalContainer } from "../../../../components/SizeGuideModal/modules/EcommContent/components/SizeGuideModal/SizeGuideModalContainer.js";
import { ReadyReaderCTA } from "../../../components/ReadyReaderCTA/modules/EcommContent/ReadyReaderEcommContent/components/ReadyReaderCTA/ReadyReaderCTA.js";
import { useProductData } from "../../../../../../context/context/product-context-hooks.js";
import { PriceSectionContainer } from "../../../../components/PriceSection/modules/EcommContent/components/PriceSection/PriceSectionContainer.js";
import { VariantSelectorTree } from "../../../../components/VariantSelectorTree/modules/EcommContent/components/VariantSelectorTree/VariantSelectorTree.js";
const ReadyReaderEcommContent = ({ className, ctaRef }) => {
  const {
    activeVariant: { displayName, sku: activeSku, isExcludedFromCheckout }
  } = useProductData();
  const { Slots } = useProductDetailSlots();
  return /* @__PURE__ */ React.createElement(
    "section",
    {
      "aria-label": displayName,
      className: classnames("ready-reader-ecomm-content", className)
    },
    /* @__PURE__ */ React.createElement(ProductTag, { className: "ready-reader-ecomm-content__tag" }),
    /* @__PURE__ */ React.createElement(PriceSectionContainer, null),
    /* @__PURE__ */ React.createElement(Hr, null),
    /* @__PURE__ */ React.createElement(VariantSelectorTree, null),
    /* @__PURE__ */ React.createElement("div", { className: "accessories-ecomm-content__column" }, /* @__PURE__ */ React.createElement(SizeGuideModalContainer, null), Slots.DynamicDeliveryIndicator ? /* @__PURE__ */ React.createElement(
      Slots.DynamicDeliveryIndicator,
      {
        isExcludedFromCheckout,
        deliveryItems: [{ sku: activeSku, quantity: 1 }]
      }
    ) : null, /* @__PURE__ */ React.createElement("div", { ref: ctaRef }, /* @__PURE__ */ React.createElement(ReadyReaderCTA, null)), Slots.AfterCTA ? /* @__PURE__ */ React.createElement(Slots.AfterCTA, null) : null)
  );
};
export {
  ReadyReaderEcommContent
};
//# sourceMappingURL=ReadyReaderEcommContent.js.map
